import _ from "lodash";
import ChartControllerBase from "./chart_controller_base";

export default class extends ChartControllerBase {
  static targets = [];

  connect() {
    this.payerTypeInputTargets = $("input[type=checkbox][name=payer_types]")
      .toArray()
      .filter(target => this.payerTypesIncluded.includes(target.value));

    $(this.payerTypeInputTargets).on("change", event => this.togglePayerTypeFromButton(event));

    this.drugInputTargets = $("input[type=checkbox][name=drugs]")
      .toArray()
      .filter(target => this.drugsIncluded.includes(target.value));

    $(this.drugInputTargets).on("change", event => this.toggleDrugFromButton(event));

    this.coverageInputTargets = $("input[name=coverage_metric_toggle]").toArray();
    $(this.coverageInputTargets).on("change", event => this.toggleCoverageMetric(event));

    $("#account_manager").on("change", () => this.updateShownPayers());
    $("#region").on("change", () => this.updateShownPayers());

    this.params = this.initializeParams();
    this.chart = this.renderChart();
  }

  togglePayerTypeFromButton(event) {
    const payerType = event.target.value;

    if (this.payerTypesIncluded.includes(payerType)) {
      this.payerTypesShown = _.xor(this.payerTypesShown, [payerType]).sort();

      this.togglePayerTypesInternal(event.target.value, event.target.checked);

      this.chart?.update();
    }
  }

  togglePayerTypeFromChart(event) {
    const { payerType } = event.target.dataset;
    const button = this.payerTypeInputTargets.find(target => target.value === payerType);

    $(button).trigger("click");
  }

  toggleDrugFromChart(event) {
    const { drug } = event.target.dataset;
    const button = this.drugInputTargets.find(target => target.value === drug);

    $(button).trigger("click");
  }

  toggleDrugFromButton(event) {
    const drug = event.target.value;

    if (this.drugsIncluded.includes(drug)) {
      this.drugs = _.xor(this.drugs, [drug]).sort();

      this.toggleDrugsInternal();

      this.chart?.update();
    }
  }

  toggleCoverageMetric() {
    this.toggleCoverageMetricInternal();

    this.chart?.update();
  }

  updateShownPayers() {
    this.updateShownPayersInternal();

    this.chart?.update();
  }

  initializeParams() {
    const params = JSON.parse(this.data.get("chartData")) || {};

    if (this.data.get("staticMode")) {
      this.payerTypesShown = (this.data.get("payer-types-included") || "")
        .split("|")
        .filter(Boolean);
      this.drugs = (this.data.get("drugs-included") || "").split("|").filter(Boolean);
    } else {
      this.payerTypesShown = this.payerTypeInputTargets
        .filter(target => target.checked)
        .map(target => target.value);

      this.drugs = _.isEmpty(this.drugInputTargets)
        ? this.drugsIncluded
        : this.drugInputTargets.filter(target => target.checked).map(target => target.value);
    }

    return params;
  }

  togglePayerTypesInternal() {
    // Implement in subclass if needed
  }

  toggleDrugsInternal() {
    // Implement in subclass if needed
  }
}
